// import React, { useEffect, useState } from "react";
// import useApi from "../../../CustomHooks/useApi";
// import { useLocation } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";


// /* ================= UPI SUFFIX MAP ================= */
// const UPI_SUFFIX_MAP = {
//     PHONEPE: ["ybl", "ibl", "axl"],
//     GOOGLEPAY: ["okicici", "okaxis", "okhdfc", "oksbi"],
//     PAYTM: ["pthdfc", "ptyes", "ptaxis", "ptsbi"],
//     AMAZON: ["apl"],
// };

// const AepsRemitter3 = () => {

//     const location = useLocation();
//     const remitter_mobile = location.state?.mobile;
//     const remitter_name = location.state?.name;
//     const mid = useSelector((s) => s.auth.employeeDetails?.username);
//     const onetimelimit = useSelector((store) => store?.auth?.employeeDetails?.oneTimeLimit);
//     const navigate = useNavigate();


//     /* ================= STATES ================= */
//     const [upiList, setUpiList] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [addMode, setAddMode] = useState("VERIFY"); // VERIFY | DIRECT
//     const [manualBeneName, setManualBeneName] = useState("");

//     const [showUpiPopup, setShowUpiPopup] = useState(false);
//     const [showVerifyConfirm, setShowVerifyConfirm] = useState(false);
//     const [customerDetails, setCustomerDetails] = useState(null);

//     const [upiType, setUpiType] = useState("BANK");
//     const [vpa, setVpa] = useState("");
//     const [upiSuffix, setUpiSuffix] = useState("");
//     const [beneName, setBeneName] = useState("");
//     const [msg, setMsg] = useState("");
//     const [amountMap, setAmountMap] = useState({});

//     const [isVerified, setIsVerified] = useState(false);
//     const [verifying, setVerifying] = useState(false);
//     const [amountErrorMap, setAmountErrorMap] = useState({});
//     const [confirmType, setConfirmType] = useState(null);


//     /* ================= API HOOKS ================= */
//     const { callApi: fetchBeneList } = useApi("/payout/bene/list", "GET");
//     const { callApi: fetchCustomerDetails } = useApi(
//         "/payout/customer/details",
//         "GET"
//     );
//     const { callApi: verifyUpiApi } = useApi("/payout/verify", "POST");
//     const { callApi: addUpiApi } = useApi("/payout/bene/verify", "POST");

//     /* ================= LOAD BENE UPI LIST ================= */
//     useEffect(() => {
//         if (remitter_mobile) {
//             getUpiList();
//             getCustomerDetails();
//         }
//     }, [remitter_mobile]);

//     const getUpiList = async () => {
//         setLoading(true);
//         try {
//             const res = await fetchBeneList(null, `?mobile=${remitter_mobile}`);
//             const list = Array.isArray(res) ? res : res?.data || [];
//             setUpiList(list);
//         } catch (e) {
//             console.error("BENE LIST ERROR", e);
//             setUpiList([]);
//         }
//         setLoading(false);
//     };

//     const getCustomerDetails = async () => {
//         try {
//             const res = await fetchCustomerDetails(null, `?mobile=${remitter_mobile}`);
//             setCustomerDetails(res);
//         } catch (err) {
//             console.error("CUSTOMER DETAILS ERROR", err);
//         }
//     };


//     /* ================= VERIFY BUTTON CLICK ================= */
//     const handleVerifyUpi = () => {
//         if (!vpa) return setMsg("Enter UPI ID first");
//         setShowVerifyConfirm(true);
//     };

//     /* ================= CONFIRM VERIFY API ================= */
//     const verifyAndAddUpi = async () => {
//         setVerifying(true);
//         setMsg("");

//         try {
//             /* ================= VERIFY UPI ================= */
//             const verifyRes = await verifyUpiApi({ upiId: vpa, mid });

//             if (verifyRes?.status !== "SUCCESS" || !verifyRes?.accountExists) {
//                 setMsg(verifyRes?.message || "UPI verification failed");
//                 setShowVerifyConfirm(false)
//                 return;
//             }

//             const verifiedName = verifyRes?.nameAtBank || "";
//             setBeneName(verifiedName);

//             /* ================= ADD UPI ================= */
//             const addRes = await addUpiApi({
//                 customerMobile: remitter_mobile,
//                 upiId: vpa,
//                 beneName: verifiedName,
//                 isVerified: true,
//             });

//             if (addRes?.verified === true) {
//                 setMsg(addRes?.message || "UPI added successfully");

//                 setShowVerifyConfirm(false); // close confirm popup
//                 setShowUpiPopup(false);      // close main popup

//                 getUpiList();
//                 getCustomerDetails();
//             } else {
//                 setMsg(addRes?.message || "Failed to add UPI");
//             }

//         } catch (err) {
//             console.error("VERIFY & ADD ERROR:", err);
//             setMsg("Something went wrong. Please try again.");
//         } finally {
//             setVerifying(false);
//         }
//     };




//     const handleSendMoney = (bene) => {
//         const amount = amountMap[bene.id];

//         if (!amount || Number(amount) <= 0) {
//             alert("Please enter a valid amount");
//             return;
//         }

//         navigate("/aepsfundtransfer2", {
//             state: {
//                 amount: Number(amount),
//                 customerMobile: remitter_mobile,
//                 selectedBeneficiary: [
//                     {
//                         beneficiaryName: bene.beneName,
//                         accountNo: bene.upiId,
//                         ifscCode: "UPI",
//                         bankName: bene.bankName,
//                     },
//                 ],
//             },
//         });
//     };


//     const addUpiDirectly = async () => {
//         if (!vpa) {
//             setMsg("Enter UPI ID");
//             return;
//         }

//         if (!manualBeneName) {
//             setMsg("Enter beneficiary name");
//             return;
//         }

//         setVerifying(true);
//         setMsg("");

//         try {
//             const res = await addUpiApi({
//                 customerMobile: remitter_mobile,
//                 upiId: vpa,
//                 beneName: manualBeneName,
//                 isVerified: false,
//             });

//             if (res?.status === "SUCCESS") {
//                 setMsg(res?.message);

//                 setShowVerifyConfirm(false); // close confirm popup
//                 setShowUpiPopup(false);      // close main popup

//                 getUpiList();
//                 getCustomerDetails();
//             } else {
//                 setMsg(res?.message || "Failed to add UPI");
//             }
//         } catch (err) {
//             console.error("DIRECT ADD ERROR", err);
//             setMsg("Something went wrong");
//         } finally {
//             setVerifying(false);
//         }
//     };

//     return (
//         <div className="min-h-screen bg-gradient-to-br from-slate-50 via-indigo-50 to-cyan-50 py-10">
//             <div className="max-w-7xl mx-auto px-4 space-y-8">

//                 {/* ================= REMITTER PROFILE ================= */}
//                 <div className="bg-white/90 backdrop-blur-xl rounded-2xl border shadow-lg px-6 py-4">
//                     <div className="flex items-center justify-between">

//                         {/* LEFT SIDE NAME + MOBILE */}
//                         <div className="flex items-center gap-2 text-sm font-semibold text-slate-800">
//                             <span>
//                                 {customerDetails?.name}
//                             </span>

//                             <span className="text-slate-400">|</span>

//                             <span className="text-indigo-600">
//                                 {customerDetails?.mobile}
//                             </span>
//                         </div>

//                         {/* RIGHT SIDE BUTTON */}
//                         <button
//                             onClick={() => {
//                                 setShowUpiPopup(true);
//                                 setVpa("");
//                                 setBeneName("");
//                                 setManualBeneName("");
//                                 setMsg("");
//                                 setIsVerified(false);
//                                 setUpiType("BANK");
//                                 setUpiSuffix("");
//                                 setAddMode("VERIFY");
//                             }}
//                             className="px-4 py-2 text-sm font-semibold bg-gradient-to-r from-indigo-600 to-cyan-500 text-white rounded-lg shadow hover:shadow-md transition"
//                         >
//                             + Add UPI
//                         </button>

//                     </div>
//                 </div>



//                 {/* ================= BENE LIST TABLE ================= */}
//              <div className="bg-white rounded-3xl border shadow-sm overflow-x-auto overflow-y-auto">
//                     <table className="w-full text-sm">
//                         <thead className="bg-slate-100">
//                             <tr>
//                                 <th className="px-4 py-3 text-left">Name</th>
//                                 <th className="px-4 py-3 text-left">UPI ID</th>
//                                 <th className="px-4 py-3 text-left">Bank</th>
//                                 <th className="px-4 py-3 text-left">Status</th>
//                                 <th className="px-4 py-3 text-left">Amount</th>
//                                 <th className="px-4 py-3 text-left">Action</th>
//                             </tr>
//                         </thead>

//                         <tbody className="divide-y">
//                             {loading ? (
//                                 <tr>
//                                     <td colSpan="6" className="py-6 text-center">
//                                         Loading...
//                                     </td>
//                                 </tr>
//                             ) : upiList.length === 0 ? (
//                                 <tr>
//                                     <td colSpan="6" className="py-6 text-center">
//                                         No Beneficiary Found
//                                     </td>
//                                 </tr>
//                             ) : (
//                                 upiList.map((item) => {
//                                     const amount = Number(amountMap[item.id]);
//                                     const isValidAmount =
//                                         amount >= 100 &&
//                                         amount <= onetimelimit &&
//                                         !amountErrorMap[item.id];
//                                     return (
//                                         <tr key={item.id} className="hover:bg-slate-50">
//                                             <td className="px-4 py-3 font-medium">
//                                                 {item.beneName}
//                                             </td>

//                                             <td className="px-4 py-3">
//                                                 {item.upiId}
//                                             </td>

//                                             <td className="px-4 py-3">
//                                                 {item.bankName}
//                                             </td>

//                                             <td className="px-4 py-3">
//                                                 {item.isVerified ? (
//                                                     <span className="text-green-600 font-semibold">
//                                                         ✔ Verified
//                                                     </span>
//                                                 ) : (
//                                                     <span className="text-orange-500">
//                                                         Not Verified
//                                                     </span>
//                                                 )}
//                                             </td>

//                                             {/* AMOUNT INPUT */}
//                                             <td className="px-4 py-3 align-top">
//                                                 <div className="flex flex-col">
//                                                     <input
//                                                         type="text"
//                                                         min={100}
//                                                         max={onetimelimit}
//                                                         step="1"
//                                                         inputMode="numeric"
//                                                         placeholder="₹ Amount"
//                                                         value={amountMap[item.id] || ""}
//                                                         onChange={(e) => {
//                                                             const value = e.target.value;

//                                                             if (value === "") {
//                                                                 setAmountMap((prev) => ({ ...prev, [item.id]: "" }));
//                                                                 setAmountErrorMap((prev) => ({ ...prev, [item.id]: "" }));
//                                                                 return;
//                                                             }

//                                                             const num = Number(value);

//                                                             if (num < 100) {
//                                                                 setAmountErrorMap((prev) => ({
//                                                                     ...prev,
//                                                                     [item.id]: "Minimum ₹100",
//                                                                 }));
//                                                             } else if (num > onetimelimit) {
//                                                                 setAmountErrorMap((prev) => ({
//                                                                     ...prev,
//                                                                     [item.id]: `Max ${onetimelimit}`,
//                                                                 }));
//                                                             } else {
//                                                                 setAmountErrorMap((prev) => ({ ...prev, [item.id]: "" }));
//                                                             }

//                                                             if (num >= 0 && num <= onetimelimit) {
//                                                                 setAmountMap((prev) => ({ ...prev, [item.id]: num }));
//                                                             }
//                                                         }}
//                                                         className={`w-28 px-3 py-2 border rounded-lg text-sm
//         focus:ring-2 outline-none
//         ${amountErrorMap[item.id]
//                                                                 ? "border-red-500 focus:ring-red-400"
//                                                                 : "focus:ring-indigo-500"
//                                                             }`}
//                                                     />

//                                                     {/* 🔒 FIXED HEIGHT ERROR SLOT (NO FLICKER) */}
//                                                     <div className="h-4 mt-1">
//                                                         {amountErrorMap[item.id] && (
//                                                             <p className="text-xs text-red-600 leading-tight">
//                                                                 {amountErrorMap[item.id]}
//                                                             </p>
//                                                         )}
//                                                     </div>
//                                                 </div>
//                                             </td>



//                                             {/* ACTION */}
//                                             <td className="px-4 py-3">
//                                                 <button
//                                                     onClick={() => handleSendMoney(item)}
//                                                     disabled={!isValidAmount}
//                                                     className={`px-4 py-2 text-sm font-semibold rounded-lg transition
//     ${isValidAmount
//                                                             ? "bg-indigo-600 text-white hover:bg-indigo-700"
//                                                             : "bg-gray-300 text-gray-600 cursor-not-allowed"
//                                                         }`}
//                                                 >
//                                                     Send Money
//                                                 </button>
//                                             </td>
//                                         </tr>
//                                     )
//                                 }
//                                 ))}
//                         </tbody>
//                     </table>
//                 </div>

//             </div>

//             {/* ================= ADD UPI MODAL ================= */}
//             {showUpiPopup && (
//                 <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50">
//                     <div className="bg-white w-full max-w-lg rounded-2xl shadow-2xl overflow-hidden">

//                         {/* HEADER */}
//                         <div className="px-6 py-4 bg-gradient-to-r from-indigo-600 to-cyan-500 text-white flex justify-between items-center">
//                             <h2 className="text-lg font-semibold">Add UPI Beneficiary</h2>
//                             <button
//                                 onClick={() => setShowUpiPopup(false)}
//                                 className="text-white text-xl leading-none"
//                             >
//                                 ×
//                             </button>
//                         </div>

//                         {/* BODY */}
//                         <div className="p-6 space-y-6">

//                             {/* ADD MODE */}
//                             {/* <div>
//                                 <p className="text-sm font-semibold mb-2">Choose Add Mode</p>
//                                 <div className="grid grid-cols-2 gap-3">
//                                     <button
//                                         onClick={() => setAddMode("VERIFY")}
//                                         className={`py-3 rounded-xl border font-semibold transition
//               ${addMode === "VERIFY"
//                                                 ? "bg-indigo-600 text-white shadow"
//                                                 : "bg-white border-slate-300"}`}
//                                     >
//                                         Verify UPI<br />
//                                         <span className="text-xs opacity-80">₹3 Charge</span>
//                                     </button>

//                                     <button
//                                         onClick={() => setAddMode("DIRECT")}
//                                         className={`py-3 rounded-xl border font-semibold transition
//               ${addMode === "DIRECT"
//                                                 ? "bg-emerald-600 text-white shadow"
//                                                 : "bg-white border-slate-300"}`}
//                                     >
//                                         Add Without Verify<br />
//                                         <span className="text-xs opacity-80">₹0 Charge</span>
//                                     </button>
//                                 </div>
//                             </div> */}

//                             {/* PROVIDER */}
//                             <div>
//                                 <p className="text-sm font-semibold mb-2">UPI Provider</p>
//                                 <div className="flex flex-wrap gap-2">
//                                     {["BANK", "PHONEPE", "GOOGLEPAY", "PAYTM", "AMAZON"].map(type => (
//                                         <button
//                                             key={type}
//                                             onClick={() => {
//                                                 setUpiType(type);
//                                                 setUpiSuffix("");
//                                                 setVpa("");
//                                                 setIsVerified(false);
//                                             }}
//                                             className={`px-4 py-2 rounded-xl border text-sm font-medium
//                 ${upiType === type
//                                                     ? "bg-indigo-600 text-white"
//                                                     : "bg-white border-slate-300"}`}
//                                         >
//                                             {type}
//                                         </button>
//                                     ))}
//                                 </div>
//                             </div>

//                             {/* UPI INPUT */}
//                             <div>
//                                 <label className="text-sm font-semibold">UPI ID</label>
//                                 <input
//                                     value={vpa}
//                                     onChange={(e) => {
//                                         setVpa(e.target.value);
//                                         setIsVerified(false);
//                                     }}
//                                     placeholder="example@upi"
//                                     className="w-full px-4 py-3 mt-2 rounded-xl border
//             focus:ring-2 focus:ring-indigo-500 outline-none"
//                                 />

//                                 {UPI_SUFFIX_MAP[upiType] && (
//                                     <div className="mt-3 flex flex-wrap gap-2">
//                                         {UPI_SUFFIX_MAP[upiType].map(suffix => (
//                                             <button
//                                                 key={suffix}
//                                                 onClick={() => {
//                                                     const base = vpa.split("@")[0] || "";
//                                                     setVpa(`${base}@${suffix}`);
//                                                     setIsVerified(false);
//                                                 }}
//                                                 className="px-3 py-1.5 rounded-full border text-xs
//                   hover:bg-indigo-50 hover:border-indigo-400"
//                                             >
//                                                 @{suffix}
//                                             </button>
//                                         ))}
//                                     </div>
//                                 )}
//                             </div>

//                             {/* BENEFICIARY NAME */}
//                             <div>
//                                 <label className="text-sm font-semibold">
//                                     Beneficiary Name
//                                     {addMode === "VERIFY" && (
//                                         <span className="text-xs text-slate-500 ml-2">
//                                             (Auto-filled after verification)
//                                         </span>
//                                     )}
//                                 </label>

//                                 {addMode === "VERIFY" ? (
//                                     <input
//                                         value={beneName}
//                                         disabled
//                                         className="w-full px-4 py-3 mt-2 rounded-xl border bg-gray-100"
//                                     />
//                                 ) : (
//                                     <input
//                                         value={manualBeneName}
//                                         onChange={(e) => setManualBeneName(e.target.value)}
//                                         placeholder="Enter beneficiary name"
//                                         className="w-full px-4 py-3 mt-2 rounded-xl border
//               focus:ring-2 focus:ring-emerald-500 outline-none"
//                                     />
//                                 )}
//                             </div>

//                             {/* MESSAGE SLOT (NO JUMP) */}
//                             <div className="h-5">
//                                 {msg && <p className="text-sm text-red-600">{msg}</p>}
//                             </div>
//                         </div>

//                         {/* FOOTER */}
//                         {/* <div className="px-6 py-4 bg-slate-50 flex justify-end gap-3">
//                             <button
//                                 onClick={() => setShowUpiPopup(false)}
//                                 className="px-5 py-2 border rounded-xl"
//                             >
//                                 Cancel
//                             </button>

//                             {addMode === "VERIFY" ? (
//                                 <button
//                                     onClick={handleVerifyUpi}
//                                     className="px-6 py-2 bg-indigo-600 text-white rounded-xl hover:bg-indigo-700"
//                                 >
//                                     Verify & Add ₹3
//                                 </button>
//                             ) : (
//                                 <button
//                                     onClick={addUpiDirectly}
//                                     disabled={verifying}
//                                     className="px-6 py-2 bg-emerald-600 text-white rounded-xl hover:bg-emerald-700"
//                                 >
//                                     {verifying ? "Adding..." : "Add UPI"}
//                                 </button>
//                             )}
//                         </div> */}

//                         <div className="px-6 py-4 bg-slate-50 flex justify-end gap-3">



//                             {/* VERIFY */}
//                             <button
//                                 onClick={() => {
//                                     if (!vpa) {
//                                         setMsg("Enter UPI ID");
//                                         return;
//                                     }

//                                     setAddMode("VERIFY");
//                                     setConfirmType("VERIFY");
//                                     setShowVerifyConfirm(true);   // ✅ popup open
//                                 }}
//                                 className="px-6 py-2 rounded-xl font-semibold text-white
//                bg-indigo-600 hover:bg-indigo-700"
//                             >
//                                 Verify & Add ₹3
//                             </button>
//                             {/* ADD WITHOUT VERIFY */}
//                             <button
//                                 onClick={() => {
//                                     if (!vpa) {
//                                         setMsg("Enter UPI ID");
//                                         return;
//                                     }
//                                     setAddMode("DIRECT");
//                                     if (!manualBeneName) {
//                                         setMsg("Enter beneficiary name");
//                                         return;
//                                     }

//                                     setConfirmType("DIRECT");
//                                     setShowVerifyConfirm(true); // ✅ popup open
//                                 }}
//                                 className="px-5 py-2 rounded-xl font-semibold text-white
//              bg-red-600 hover:bg-red-700 active:bg-red-800"
//                             >
//                                 Add Without Verify ₹0
//                             </button>


//                         </div>



//                     </div>
//                 </div>
//             )}


//             {/* ================= VERIFY CONFIRM MODAL ================= */}
//             {showVerifyConfirm && (
//                 <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[60]">
//                     <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6">

//                         {/* Title */}
//                         <h3 className="text-lg font-semibold text-gray-900">
//                             {confirmType === "VERIFY"
//                                 ? "Verify UPI ID / UPI ID सत्यापित करें"
//                                 : "Add UPI Without Verification / बिना सत्यापन के UPI जोड़ें"}
//                         </h3>

//                         {/* Description */}
//                         <p className="text-sm text-slate-600 mt-2 leading-relaxed">
//                             {confirmType === "VERIFY" ? (
//                                 <>
//                                     ₹3 will be deducted for UPI verification.
//                                     <br />
//                                     <span className="text-xs text-gray-500">
//                                         (UPI सत्यापन के लिए ₹3 काटे जाएंगे।)
//                                     </span>
//                                 </>
//                             ) : (
//                                 <>
//                                     No charge will be deducted. UPI will be added without verification.
//                                     <br />
//                                     <span className="text-xs text-gray-500">
//                                         (कोई शुल्क नहीं काटा जाएगा। UPI बिना सत्यापन के जोड़ दिया जाएगा।)
//                                     </span>
//                                 </>
//                             )}
//                         </p>

//                         {/* UPI Display */}
//                         <div className="mt-4 p-3 bg-gray-50 border rounded-lg text-sm">
//                             <b>UPI ID / UPI आईडी:</b> {vpa}
//                         </div>

//                         {/* Actions */}
//                         <div className="flex justify-end gap-3 mt-6">
//                             <button
//                                 onClick={() => setShowVerifyConfirm(false)}
//                                 className="px-4 py-2 border rounded-lg text-sm hover:bg-gray-50"
//                             >
//                                 Cancel / रद्द करें
//                             </button>

//                             <button
//                                 disabled={verifying}
//                                 onClick={() => {
//                                     if (confirmType === "VERIFY") {
//                                         verifyAndAddUpi();
//                                     } else {
//                                         addUpiDirectly();
//                                     }
//                                 }}
//                                 className={`px-5 py-2 rounded-lg text-white text-sm font-semibold disabled:opacity-60
//             ${confirmType === "VERIFY"
//                                         ? "bg-green-600 hover:bg-green-700"
//                                         : "bg-emerald-600 hover:bg-emerald-700"
//                                     }`}
//                             >
//                                 {verifying
//                                     ? "Processing... / प्रक्रिया जारी है..."
//                                     : confirmType === "VERIFY"
//                                         ? "Confirm & Verify / पुष्टि करें और सत्यापित करें"
//                                         : "Confirm & Add / पुष्टि करें और जोड़ें"}
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}



//         </div>
//     );
// };

// export default AepsRemitter3;





// import React, { useEffect, useState } from "react";
// import useApi from "../../../CustomHooks/useApi";
// import { useLocation } from "react-router-dom";
// import { useSelector } from "react-redux";

// const AepsRemitter3 = () => {
//     const location = useLocation();
//     const remitter_mobile = location.state?.mobile;

//     const mid = useSelector((s) => s.auth.employeeDetails?.username);
//     const onetimelimit = useSelector(
//         (store) => store?.auth?.employeeDetails?.oneTimeLimit
//     );

//     /* ================= STATES ================= */
//     const [customerDetails, setCustomerDetails] = useState(null);
//     const [amount, setAmount] = useState("");
//     const [customerEmail, setCustomerEmail] = useState("");
//     const [loading, setLoading] = useState(false);
//     const [amountError, setAmountError] = useState("");
//     const [emailError, setEmailError] = useState("");
//     const [msg, setMsg] = useState("");

//     /* ================= API HOOKS ================= */
//     const { callApi: fetchCustomerDetails } = useApi(
//         "/payout/customer/details",
//         "GET"
//     );

//     const { callApi: initiateVeghaPayout } = useApi(
//         "/payout/initiate/vegha",
//         "POST"
//     );

//     /* ================= LOAD CUSTOMER ================= */
//     useEffect(() => {
//         if (remitter_mobile) {
//             getCustomerDetails();
//         }
//     }, [remitter_mobile]);

//     const getCustomerDetails = async () => {
//         try {
//             const res = await fetchCustomerDetails(
//                 null,
//                 `?mobile=${remitter_mobile}`
//             );
//             setCustomerDetails(res);
//         } catch (err) {
//             console.error("CUSTOMER DETAILS ERROR", err);
//         }
//     };

//     /* ================= VALIDATE EMAIL ================= */
//     const validateEmail = (email) => {
//         const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//         return regex.test(email);
//     };

//     /* ================= DIRECT VEGHA PAYOUT ================= */
//     const handleDirectSettlement = async () => {
//         setMsg("");

//         const numericAmount = Number(amount);

//         if (!numericAmount || numericAmount < 100) {
//             setAmountError("Minimum amount ₹100");
//             return;
//         }

//         if (numericAmount > onetimelimit) {
//             setAmountError(`Max limit ₹${onetimelimit}`);
//             return;
//         }

//         if (!customerEmail) {
//             setEmailError("Email is required");
//             return;
//         }

//         if (!validateEmail(customerEmail)) {
//             setEmailError("Enter valid email address");
//             return;
//         }

//         setAmountError("");
//         setEmailError("");

//         try {
//             setLoading(true);

//             const payload = {
//                 mid: mid,
//                 netAmount: numericAmount,
//                 txnAmount: numericAmount,
//                 customerEmail: customerEmail.trim(),
//             };

//             console.log("VEGHA PAYLOAD:", payload);

//             const res = await initiateVeghaPayout(payload);

//             console.log("VEGHA RESPONSE:", res);

//             if (res?.status === "SUCCESS") {
//                 setMsg("Settlement Successful ✅");
//                 setAmount("");
//                 setCustomerEmail("");
//             } else {
//                 setMsg(res?.message || "Settlement Failed ❌");
//             }
//         } catch (err) {
//             console.error("VEGHA ERROR:", err);
//             setMsg("Something went wrong. Please try again.");
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <div className="min-h-screen bg-gradient-to-br from-slate-50 via-indigo-50 to-cyan-50 py-10">
//             <div className="max-w-3xl mx-auto px-4 space-y-8">

//                 {/* ================= REMITTER PROFILE ================= */}
//                 <div className="bg-white/90 backdrop-blur-xl rounded-2xl border shadow-lg px-6 py-4">
//                     <div className="flex items-center justify-between text-sm font-semibold text-slate-800">
//                         <div>
//                             {customerDetails?.name || "Customer"}{" "}
//                             <span className="text-slate-400 mx-2">|</span>
//                             <span className="text-indigo-600">
//                                 {customerDetails?.mobile}
//                             </span>
//                         </div>
//                     </div>
//                 </div>

//                 {/* ================= DIRECT SETTLEMENT CARD ================= */}
//                 <div className="bg-white rounded-3xl shadow-xl p-8 space-y-6">

//                     <h2 className="text-xl font-semibold text-slate-800">
//                         Direct AEPS Settlement (VegHa)
//                     </h2>

//                     {/* EMAIL INPUT */}
//                     <div>
//                         <label className="text-sm font-semibold">
//                             Customer Email
//                         </label>
//                         <input
//                             type="email"
//                             value={customerEmail}
//                             onChange={(e) => {
//                                 setCustomerEmail(e.target.value);
//                                 setEmailError("");
//                             }}
//                             placeholder="customer@example.com"
//                             className={`w-full mt-2 px-4 py-3 rounded-xl border text-sm
//                                 focus:ring-2 outline-none
//                                 ${
//                                     emailError
//                                         ? "border-red-500 focus:ring-red-400"
//                                         : "focus:ring-indigo-500"
//                                 }`}
//                         />

//                         <div className="h-5 mt-1">
//                             {emailError && (
//                                 <p className="text-xs text-red-600">
//                                     {emailError}
//                                 </p>
//                             )}
//                         </div>
//                     </div>

//                     {/* AMOUNT INPUT */}
//                     <div>
//                         <label className="text-sm font-semibold">
//                             Enter Amount
//                         </label>
//                         <input
//                             type="text"
//                             inputMode="numeric"
//                             value={amount}
//                             onChange={(e) => {
//                                 const value = e.target.value;

//                                 if (value === "") {
//                                     setAmount("");
//                                     setAmountError("");
//                                     return;
//                                 }

//                                 const num = Number(value);

//                                 if (num < 100) {
//                                     setAmountError("Minimum ₹100");
//                                 } else if (num > onetimelimit) {
//                                     setAmountError(
//                                         `Max limit ₹${onetimelimit}`
//                                     );
//                                 } else {
//                                     setAmountError("");
//                                 }

//                                 setAmount(value);
//                             }}
//                             placeholder="₹ Amount"
//                             className={`w-full mt-2 px-4 py-3 rounded-xl border text-sm
//                                 focus:ring-2 outline-none
//                                 ${
//                                     amountError
//                                         ? "border-red-500 focus:ring-red-400"
//                                         : "focus:ring-indigo-500"
//                                 }`}
//                         />

//                         <div className="h-5 mt-1">
//                             {amountError && (
//                                 <p className="text-xs text-red-600">
//                                     {amountError}
//                                 </p>
//                             )}
//                         </div>
//                     </div>

//                     {/* SUBMIT BUTTON */}
//                     <button
//                         onClick={handleDirectSettlement}
//                         disabled={loading}
//                         className={`w-full py-3 rounded-xl text-white font-semibold transition
//                             ${
//                                 loading
//                                     ? "bg-gray-400 cursor-not-allowed"
//                                     : "bg-indigo-600 hover:bg-indigo-700"
//                             }`}
//                     >
//                         {loading ? "Processing..." : "Initiate Settlement"}
//                     </button>

//                     {/* MESSAGE */}
//                     <div className="h-6 text-center">
//                         {msg && (
//                             <p
//                                 className={`text-sm font-medium ${
//                                     msg.includes("Successful")
//                                         ? "text-green-600"
//                                         : "text-red-600"
//                                 }`}
//                             >
//                                 {msg}
//                             </p>
//                         )}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default AepsRemitter3;




import React, { useEffect, useState } from "react";
import useApi from "../../../CustomHooks/useApi";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const AepsRemitter3 = () => {
    const location = useLocation();
    const remitter_mobile = location.state?.mobile;

    const mid = useSelector((s) => s.auth.employeeDetails?.username);
    const onetimelimit = useSelector(
        (store) => store?.auth?.employeeDetails?.oneTimeLimit
    );

    /* ================= STATES ================= */
    const [customerDetails, setCustomerDetails] = useState(null);
    const [amount, setAmount] = useState("");
    const [customerEmail, setCustomerEmail] = useState("");

    const [fee, setFee] = useState(0);
    const [txnAmount, setTxnAmount] = useState(0);
    const [loadingFee, setLoadingFee] = useState(false);

    const [loading, setLoading] = useState(false);
    const [amountError, setAmountError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [msg, setMsg] = useState("");

    /* ================= API HOOKS ================= */
    const { callApi: fetchCustomerDetails } = useApi(
        "/payout/customer/details",
        "GET"
    );

    const { callApi: initiateVeghaPayout } = useApi(
        "/payout/initiate/vegha",
        "POST"
    );

    const { callApi: calculateFee } =
        useApi("/dmt/fee/calculate/aeps/settle", "POST");

    /* ================= LOAD CUSTOMER ================= */
    useEffect(() => {
        if (remitter_mobile) {
            getCustomerDetails();
        }
    }, [remitter_mobile]);

    const getCustomerDetails = async () => {
        try {
            const res = await fetchCustomerDetails(
                null,
                `?mobile=${remitter_mobile}`
            );
            setCustomerDetails(res);
        } catch (err) {
            console.error("CUSTOMER DETAILS ERROR", err);
        }
    };

    /* ================= FEE CALCULATION ================= */
    useEffect(() => {
        if (!amount || Number(amount) < 100) {
            setFee(0);
            setTxnAmount(0);
            return;
        }

        const calculateCharges = async () => {
            try {
                setLoadingFee(true);

                const res = await calculateFee({
                    paymentMode: "UPI",
                    provider: "SETTLEMENT",
                    sub_provider: "NIFI",
                    amount: Number(amount),
                    commercial_type: "TRANSACTION_FEE",
                    mid: mid
                });

                setFee(Number(res?.fee || 0));
                setTxnAmount(Number(res?.txn_amount || amount));

            } catch (err) {
                console.error("Fee calculation error:", err);
                setFee(0);
                setTxnAmount(Number(amount));
            } finally {
                setLoadingFee(false);
            }
        };

        calculateCharges();
    }, [amount, mid]);

    /* ================= VALIDATE EMAIL ================= */
    const validateEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    /* ================= DIRECT VEGHA PAYOUT ================= */
const handleDirectSettlement = async () => {
    setMsg("");

    const numericAmount = Number(amount);

    if (!numericAmount || numericAmount < 100) {
        setAmountError("Minimum amount ₹100");
        return;
    }

    if (numericAmount > onetimelimit) {
        setAmountError(`Max limit ₹${onetimelimit}`);
        return;
    }

    if (!customerEmail) {
        setEmailError("Email is required");
        return;
    }

    if (!validateEmail(customerEmail)) {
        setEmailError("Enter valid email address");
        return;
    }

    if (!txnAmount || txnAmount <= 0) {
        setMsg("Fee calculation not completed");
        return;
    }

    setAmountError("");
    setEmailError("");

    try {
        setLoading(true);

        const payload = {
            mid: mid,
            netAmount: numericAmount,
            txnAmount: txnAmount,
            customerEmail: customerEmail.trim(),
        };

        console.log("VEGHA PAYLOAD:", payload);

        const res = await initiateVeghaPayout(payload);

        console.log("VEGHA RESPONSE:", res);

        /* ================= REDIRECT LOGIC ================= */

        if (res?.status === "PENDING" && res?.redirectUrl) {
            // 🔥 Redirect user to Vegaah payment page
            window.location.href = res.redirectUrl;
            return;
        }

        if (res?.status === "SUCCESS") {
            setMsg("Settlement Successful ✅");
            setAmount("");
            setCustomerEmail("");
            setFee(0);
            setTxnAmount(0);
        } else {
            setMsg(res?.message || "Settlement Failed ❌");
        }

    } catch (err) {
        console.error("VEGHA ERROR:", err);
        setMsg("Something went wrong. Please try again.");
    } finally {
        setLoading(false);
    }
};

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-indigo-50 to-cyan-50 py-10">
            <div className="max-w-3xl mx-auto px-4 space-y-8">

                {/* REMITTER PROFILE */}
                <div className="bg-white rounded-2xl border shadow-lg px-6 py-4">
                    <div className="flex justify-between text-sm font-semibold text-slate-800">
                        <div>
                            {customerDetails?.name || "Customer"}{" "}
                            <span className="text-slate-400 mx-2">|</span>
                            <span className="text-indigo-600">
                                {customerDetails?.mobile}
                            </span>
                        </div>
                    </div>
                </div>

                {/* SETTLEMENT CARD */}
                <div className="bg-white rounded-3xl shadow-xl p-8 space-y-6">

                    <h2 className="text-xl font-semibold">
                        Direct AEPS Settlement (VegHa)
                    </h2>

                    {/* EMAIL */}
                    <div>
                        <label className="text-sm font-semibold">
                            Customer Email
                        </label>
                        <input
                            type="email"
                            value={customerEmail}
                            onChange={(e) => {
                                setCustomerEmail(e.target.value);
                                setEmailError("");
                            }}
                            placeholder="customer@example.com"
                            className={`w-full mt-2 px-4 py-3 rounded-xl border
                                ${emailError ? "border-red-500" : ""}`}
                        />
                        <div className="h-5 mt-1">
                            {emailError && (
                                <p className="text-xs text-red-600">
                                    {emailError}
                                </p>
                            )}
                        </div>
                    </div>

                    {/* AMOUNT */}
                    <div>
                        <label className="text-sm font-semibold">
                            Enter Amount
                        </label>
                        <input
                            type="number"
                            value={amount}
                            onChange={(e) => {
                                const val = e.target.value;
                                setAmount(val);
                                setAmountError("");
                            }}
                            placeholder="₹ Amount"
                            className={`w-full mt-2 px-4 py-3 rounded-xl border
                                ${amountError ? "border-red-500" : ""}`}
                        />

                        <div className="h-5 mt-1">
                            {amountError && (
                                <p className="text-xs text-red-600">
                                    {amountError}
                                </p>
                            )}
                        </div>
                    </div>

                    {/* FEE SUMMARY */}
                    <div className="bg-slate-50 border rounded-xl p-4 text-sm">
                        {loadingFee ? (
                            <p>Calculating charges…</p>
                        ) : (
                            <>
                                <div className="flex justify-between">
                                    <span>Amount</span>
                                    <span>₹ {amount || 0}</span>
                                </div>
                                <div className="flex justify-between">
                                    <span>Charges</span>
                                    <span>₹ {fee}</span>
                                </div>
                                <div className="flex justify-between font-semibold pt-2 border-t">
                                    <span>Total Debit</span>
                                    <span>₹ {txnAmount}</span>
                                </div>
                            </>
                        )}
                    </div>

                    {/* BUTTON */}
                    <button
                        onClick={handleDirectSettlement}
                        disabled={loading || loadingFee}
                        className={`w-full py-3 rounded-xl text-white font-semibold
                            ${loading || loadingFee
                                ? "bg-gray-400"
                                : "bg-indigo-600 hover:bg-indigo-700"
                            }`}
                    >
                        {loading ? "Processing..." : "Initiate Settlement"}
                    </button>

                    {/* MESSAGE */}
                    <div className="h-6 text-center">
                        {msg && (
                            <p className="text-sm font-medium">
                                {msg}
                            </p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AepsRemitter3;

